import { BRangeCleaningCommandType } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

/** Status sent with a Beep / Blink command, and reported back in Device.settings. */
export enum LocateStatus {
  Off = 0,
  On = 1,
}

// How long a queued command may take to show on the robot before the control gives up waiting.
export const COMMAND_CONFIRMATION_TIMEOUT_MS = 30_000;

// The device may replay an older Beep / Blink state after a command is confirmed; a contradicting report is ignored.
export const LOCATE_SETTLE_MS = 10_000;

export enum RobotCleaningControlAction {
  Pause = 'pause',
  Resume = 'resume',
  CancelCleaning = 'cancelCleaning',
  SendHome = 'sendHome',
  SkipRoute = 'skipRoute',
}

export const CLEANING_CONTROL_ACTION_TO_COMMAND_TYPE: Record<RobotCleaningControlAction, BRangeCleaningCommandType> = {
  [RobotCleaningControlAction.Pause]: BRangeCleaningCommandType.MissionPause,
  [RobotCleaningControlAction.Resume]: BRangeCleaningCommandType.MissionResume,
  [RobotCleaningControlAction.CancelCleaning]: BRangeCleaningCommandType.MissionStop,
  [RobotCleaningControlAction.SendHome]: BRangeCleaningCommandType.MissionDriveBackAndCancel,
  [RobotCleaningControlAction.SkipRoute]: BRangeCleaningCommandType.MissionDriveBackAndSkip,
};

// The robot's state can't reliably show these took effect, so only the request is awaited.
export const REQUEST_ONLY_COMMAND_TYPES: BRangeCleaningCommandType[] = [
  BRangeCleaningCommandType.MissionStop,
  BRangeCleaningCommandType.MissionDriveBackAndCancel,
  BRangeCleaningCommandType.MissionDriveBackAndSkip,
];

export const CLEANING_COMMAND_TYPE_TO_ACTION_KEY: Partial<Record<BRangeCleaningCommandType, string>> = {
  [BRangeCleaningCommandType.MissionPause]: RobotCleaningControlAction.Pause,
  [BRangeCleaningCommandType.MissionResume]: RobotCleaningControlAction.Resume,
  [BRangeCleaningCommandType.MissionStop]: RobotCleaningControlAction.CancelCleaning,
  [BRangeCleaningCommandType.MissionDriveBackAndCancel]: RobotCleaningControlAction.SendHome,
  [BRangeCleaningCommandType.MissionDriveBackAndSkip]: RobotCleaningControlAction.SkipRoute,
};
